import React, { useContext, useState, useEffect } from 'react';
import { useCallback } from 'react';

const PatientDocumentContext = React.createContext({
	document: null,
	code: null
});

export const PatientDocumentProvider = ({ children }) => {
	const [info, setInfo] = useState({
		document: null,
		code: null
	});

	const clearFormAndStorage = useCallback(() => {
		setInfo({
			document: null,
			code: null
		});

		localStorage.removeItem('documentInfo');
	}, [])

	useEffect(() => {
		const localStorageInfo = localStorage.getItem('documentInfo');
		const localStorageInfoParsed = localStorageInfo ? JSON.parse(localStorageInfo) : null;

		if (localStorageInfoParsed) {
			setInfo(localStorageInfoParsed);
		}
	}, []);

	useEffect(() => {
		localStorage.setItem('documentInfo', JSON.stringify(info));
	}, [info]);

	return (
		<PatientDocumentContext.Provider value={{
			...info,
			setInfo,
			clearFormAndStorage
		}}>
			{children}
		</PatientDocumentContext.Provider>
	)
}

export const usePatientDocumentContext = () => useContext(PatientDocumentContext);
